var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('van-loading',{staticClass:"loading",attrs:{"type":"spinner","color":_vm.color,"size":"36px"}},[_vm._v("\n    数据加载中...\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }